import api from "../api/axios";

export const loginSuperAdmin = async (email, password) => {
    const response = await api.post("/login", {
        email,
        password,
    });

    return response.data;   
};